// extracted by mini-css-extract-plugin
module.exports = {"cross":"Cross_cross__qA_0u"};